import { Component } from '@angular/core';
import { Title, User, TranslatePipe, UrlPipe } from '@spartacus/core';
import { UpdateProfileComponent, UpdateProfileComponentService } from '@spartacus/user/profile/components';
import { Observable } from 'rxjs';
import { SpinnerComponent, FormErrorsComponent } from '@spartacus/storefront';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'knbr-update-profile',
    templateUrl: './kn-br-update-profile.component.html',
    imports: [SpinnerComponent, ReactiveFormsModule, FormErrorsComponent, RouterLink, AsyncPipe, TranslatePipe, UrlPipe]
})
export class KnBrUpdateProfileComponent extends UpdateProfileComponent {
  titles$: Observable<Title[]>;
  user$: Observable<User>;
  loading$: Observable<boolean>;

  constructor(protected service: UpdateProfileComponentService) {
    super(service);
  }
}
